import { render, staticRenderFns } from "./TranslatedValueFormPart.vue?vue&type=template&id=1cc258fa&scoped=true"
import script from "./TranslatedValueFormPart.vue?vue&type=script&lang=ts"
export * from "./TranslatedValueFormPart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc258fa",
  null
  
)

export default component.exports